import classNames from 'classnames';
import { forwardRef } from 'react';
import UnstyledMenuActionItem from './action_item';
const menuActionItemCss = "m1lzoarp";
export const MenuActionItem = forwardRef((props, ref) => <UnstyledMenuActionItem ref={ref} {...props} className={classNames(menuActionItemCss, props.className)} />);
const groupHeaderCss = "g15v2gxo";
export const GroupHeader = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'li';
  return <Component ref={ref} {...restProps} className={classNames(groupHeaderCss, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");